// extracted by mini-css-extract-plugin
export var arrowDown = "PickSlipPick-module--arrowDown--0bbf8";
export var arrowUp = "PickSlipPick-module--arrowUp--2c5a5";
export var back = "PickSlipPick-module--back--8f92e";
export var button = "PickSlipPick-module--button--6a451";
export var buttons = "PickSlipPick-module--buttons--846d2";
export var clamp = "PickSlipPick-module--clamp--5852a";
export var close = "PickSlipPick-module--close--7999c";
export var container = "PickSlipPick-module--container--2f0f8";
export var content = "PickSlipPick-module--content--86a56";
export var down = "PickSlipPick-module--down--d9d56";
export var enter = "PickSlipPick-module--enter--d9207";
export var eventName = "PickSlipPick-module--eventName--37617";
export var eventNamePickSlip = "PickSlipPick-module--eventNamePickSlip--d66af";
export var exoticTitle = "PickSlipPick-module--exoticTitle--b8ba0";
export var footer = "PickSlipPick-module--footer--a6347";
export var header = "PickSlipPick-module--header--370d0";
export var hidden = "PickSlipPick-module--hidden--cde16";
export var icon = "PickSlipPick-module--icon--08c1b";
export var iconButton = "PickSlipPick-module--iconButton--c42df";
export var info = "PickSlipPick-module--info--cdda2";
export var isReviewing = "PickSlipPick-module--isReviewing--b899b";
export var label = "PickSlipPick-module--label--1ae16";
export var largeFooter = "PickSlipPick-module--largeFooter--d4336";
export var lockIcon = "PickSlipPick-module--lockIcon--e1d81";
export var marketName = "PickSlipPick-module--marketName--c5ba0";
export var matchInfo = "PickSlipPick-module--matchInfo--453ce";
export var odds = "PickSlipPick-module--odds--5b1f2";
export var oddsWrapper = "PickSlipPick-module--oddsWrapper--8d3bf";
export var oldOdds = "PickSlipPick-module--oldOdds--5293f";
export var outcomeIcon = "PickSlipPick-module--outcomeIcon--be9d5";
export var panel = "PickSlipPick-module--panel--ba0cb";
export var pickContent = "PickSlipPick-module--pickContent--e1a7a";
export var pickIcon = "PickSlipPick-module--pickIcon--268a3";
export var reuseBetsButton = "PickSlipPick-module--reuseBetsButton--ca475";
export var right = "PickSlipPick-module--right--71a8d";
export var scratched = "PickSlipPick-module--scratched--d93e8";
export var scrollArea = "PickSlipPick-module--scrollArea--20439";
export var selectionName = "PickSlipPick-module--selectionName--fb517";
export var small = "PickSlipPick-module--small--69b95";
export var smallFooter = "PickSlipPick-module--smallFooter--9426c";
export var starts = "PickSlipPick-module--starts--daa20";
export var statusWithStream = "PickSlipPick-module--statusWithStream--0d4cd";
export var tab = "PickSlipPick-module--tab--04fad";
export var tabList = "PickSlipPick-module--tabList--48caa";
export var tabListContainer = "PickSlipPick-module--tabListContainer--e53f7";
export var tabs = "PickSlipPick-module--tabs--2c700";
export var title = "PickSlipPick-module--title--99a5a";
export var trash = "PickSlipPick-module--trash--aa0cb";
export var up = "PickSlipPick-module--up--110c4";
export var value = "PickSlipPick-module--value--bedaa";